module.exports = __webpack_public_path__ + "img/divide14-4.2cfa2b78.svg";